var Queensland = "퀸즐랜드";
var Tasmania = "타스마니아";
var Victoria = "빅토리아";
var AUStates = {
	"Australian Capital Territory": "오스트레일리아 수도 주",
	"New South Wales": "뉴사우스웨일스",
	"Northern Territory": "노던 준주",
	Queensland: Queensland,
	"South Australia": "사우스오스트레일리아",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "웨스턴오스트레일리아"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
